import { createSlice } from "@reduxjs/toolkit";

export const rtaOfficesSlice = createSlice({
  name: "rtaOffices",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    rtaOfficesList: [],
    model: false,
    error_msg: null,
    rowdata: {},
    rtaOfficesParams: {
      no_of_pages: 0,
      listCount: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getRtaOffices: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    rtaOfficesListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.rtaOfficesParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.response.count,
        rtaOfficesList: action.payload.response.results,
        loading: false,
        rtaOfficesParams: {
          ...state.rtaOfficesParams,
          no_of_pages: noofpages,
        },
      };
    },
    rtaOfficesAdd: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    rtaOfficesCreate: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    rtaOfficesUpdate: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    rtaOfficesAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {},
      };
    },
    rtaOfficesEdit: (state, action) => {
      return {
        ...state,
        model: true,
        rowdata: action.payload,
      };
    },
    rtaOfficesEditSuccessful: (state) => {
      return { ...state, loading: false, rowdata: {} };
    },
    rtaOfficesDelete: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },
    SetRtaOfficesParams: (state, action) => {
      return {
        ...state,
        rtaOfficesParams: action.payload,
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getRtaOffices,
  rtaOfficesListSuccessful,
  rtaOfficesAdd,
  rtaOfficesCreate,
  rtaOfficesUpdate,
  rtaOfficesAddSuccessful,
  rtaOfficesEdit,
  rtaOfficesEditSuccessful,
  rtaOfficesDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
  SetRtaOfficesParams
} = rtaOfficesSlice.actions;

export default rtaOfficesSlice.reducer;
